'use client';

import {Variant} from '@/types';

/**
 * Client-side wrapper for analytics functions that handles server actions
 * This prevents client/server boundary issues and provides better error handling
 */

export const safeTrackProductView = (variant: Variant) => {
    // Only run on client side
    if (typeof window === 'undefined') {
        return Promise.resolve();
    }

    // Import the server action dynamically to avoid bundling issues
    return import('@/rest/analytics').then(({trackProductView}) => {
        return trackProductView(variant);
    }).catch(error => {
        // Log error but don't throw - analytics failures shouldn't break the app
        console.debug('Analytics tracking failed:', error);
        return Promise.resolve();
    });
};

/**
 * Fire-and-forget analytics tracking that won't block the UI
 */
export const trackProductViewAsync = (variant: Variant) => {
    // Use setTimeout to make it truly async and non-blocking
    setTimeout(() => {
        safeTrackProductView(variant).catch(() => {
            // Already handled in safeTrackProductView
        });
    }, 0);
};
